import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { BaseSchema_PetHealthV1GetsafeDe } from '@flows/insurance/schemas'

const living_environment = (params: StepConfigParams) =>
  ({
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getParamPath('living_environment')]:
        BaseSchema_PetHealthV1GetsafeDe.shape.living_environment.unwrap(),
    }),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_petHealth:steps.living_environment.title',
          values: {
            pet_name: {
              type: 'dynamicValue',
              path: params.helperFunctions.getParamPath('pet_name'),
            },
          },
        },
      },
      {
        type: 'choice',
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('living_environment'),
        options: [
          {
            value: 'indoor',
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_petHealth:steps.living_environment.indoor',
            },
          },
          {
            value: 'outdoor',
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_petHealth:steps.living_environment.indoor_outdoor',
            },
          },
        ],
      },
    ],
    subFlow: params.subFlow,
    nextStep: 'pet_quote',
  }) as const satisfies AnyStepConfiguration

export default living_environment
